module.exports = __webpack_public_path__ + "img/avatar_rocketsledge.8b4bd8ad.png";